import styled from "styled-components";

export const Main = styled.div`
  width: 150px;
  padding: 0;
`;

export const Styled = styled.div`
  max-width: 520px;
  width: 100%;

  .select {
    h4 { width: 50px; }
  }
  .action {
    margin: 12px 0;
    border-bottom: 1px solid #e5e7eb;
  }

  /* Watch Type Selection */
  .watch-type-section {
    margin-bottom: 16px;
    margin-top: 16px;
  }

  .watch-type-section h4 {
    margin: 0 0 8px 0;
    color: #333;
    font-size: 14px;
    font-weight: 600;
  }

  .watch-type-buttons {
    display: flex;
    gap: 8px;
  }

  .type-button {
   display: flex;
   align-items: center;
   justify-content: center;
    flex: 1;
    padding: 0 16px;
    height: 40px;
    border: 2px solid #ddd;
    background: #fff;
    color: #374151;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all .2s ease-in-out;

    svg {
      margin-right: 7.5px;
    }
  }

  .type-button:hover:not(:disabled) {
    border-color: rgb(64, 134, 244);
    background: #eff6ff;
    color: rgb(64, 134, 244);
  }

  .type-button.active {
    border-color: rgb(64, 134, 244);
    background: rgb(64, 134, 244);
    color: white;
    pointer-events: none;
  }

  .type-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Disabled selection section */
  .selection-section.disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Help Text */
  .help-text {
    padding: 10px;
    background: #fef3c7;
    border: 1px solid #fbbf24;
    border-radius: 6px;
    font-size: 12px;
    color: #92400e;
    line-height: 1.5;
    margin-bottom: 12px;
  }

  .help-text code {
    display: block;
    margin-top: 6px;
    padding: 6px;
    background: #fffbeb;
    border-radius: 4px;
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
    font-size: 11px;
    color: #78350f;
  }

  .help-text strong {
    color: #b45309;
    font-weight: 600;
  }

  /* Watch Section */
  .watch-section {
    margin: 16px 0 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .watch-button {
    width: 100%;
    border: none;
    border-radius: 6px;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all .2s ease-in-out;
  }

  .watch-button.enable {
    background: #323432ff;
    color: white;

    &:hover {
      box-shadow: 0 0 10px #323432ff;
      opacity: 0.9;
    }
  }

  .watch-button.enable:hover:not(:disabled) {
    background: #323432ff;
  }

  .watch-button.disable {
    background: #ef4444;
    color: white;
  }

  .watch-button.disable:hover:not(:disabled) {
    background: #dc2626;
    box-shadow: 0 0 10px #dc2626;
    opacity: 0.9;
  }

  .watch-button:disabled {
    cursor: not-allowed;
    background: #9ca3af;
  }

  .watch-status {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.4;
    text-align: center;
  }

  .watch-status.success {
    background: #d1fae5;
    color: #065f46;
    border: 1px solid #10b981;
  }

  .watch-status.error {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #ef4444;
  }

  .watch-status.info {
    background: #dbeafe;
    color: #1e40af;
    border: 1px solid #3b82f6;
  }

  /* Watch Info */
  .watch-info {
    margin: 16px 0;
    padding: 12px;
    background: #f0f9ff;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
  }

  .watch-info h5 {
    margin: 0 0 8px 0;
    color: #1e40af;
    font-size: 13px;
    font-weight: 600;
  }

  .watch-info ul {
    margin: 0;
    padding-left: 0;
    list-style: none;
  }

  .watch-info li {
    margin-bottom: 4px;
    font-size: 12px;
    color: #1e3a8a;
  }

  .watch-info strong {
    font-weight: 600;
  }

  .watch-info .status-enabled {
    color: #10b981;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 11px;
  }

  .watch-info .status-disabled {
    color: #f59e0b;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 11px;
  }

  /* Page Token Info */
  .page-token-info {
    padding: 8px;
    background: #f3f4f6;
    border-radius: 4px;
    margin: 12px 0;
  }

  .page-token-info small {
    font-size: 11px;
    color: #6b7280;
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  }

  .page-token-info strong {
    color: #374151;
    font-weight: 600;
  }

  /* Events Info */
  .events-info {
    margin: 16px 0 0 0;
    padding: 12px;
    background: #ecfdf5;
    border: 1px solid #a7f3d0;
    border-radius: 6px;
  }

  .events-info h5 {
    margin: 0 0 10px 0;
    color: #065f46;
    font-size: 13px;
    font-weight: 600;
  }

  .event-types {
    margin: 0;
    padding-left: 0;
    list-style: none;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .event-types li {
    padding: 6px 8px;
    font-size: 12px;
    color: #047857;
    background: #d1fae5;
    border-radius: 4px;
    border: 1px solid #6ee7b7;
  }
`;

export const Loader = styled.span`
  width: 68px;
  height: 68px;
  border: 5px solid #9ca3af;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin: 0 auto;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;